<template>
    <div>
        <div class='lt-md absolute-center row justify-center text-center q-headline'><div class='q-display-1'>Извините!</div>
            Раздел не оптимизирован для низкого разрешения.</div>
        <div class='gt-sm'>
            <div class="q-pa-lg">
                <!-- Диалог add|edit банковский приход -->

                <q-modal v-model="chargeDialog" maximized>

                    
                    <form id="chargeEditForm" action="#"  @submit.prevent="saveCharge">
                    
                        <q-modal-layout class='full-width'>
                            <q-toolbar slot="header">
                            <q-toolbar-title>
                                Редактирование
                            </q-toolbar-title>

                            <q-btn
                                color="negative"
                                label="Отмена"
                                icon = "cancel"
                                wait-for-ripple
                                class='q-mr-md'
                                @click ='cancelChargeDialog'
                            />
                            
                            <q-btn
                                color="green"
                                label="Сохранить"
                                icon = "save"
                                wait-for-ripple
                                type="submit"
                            />
                            </q-toolbar>

                            <div class="row no-wrap full-width q-pa-lg justify-center">
                                <div class="col-8 justify-center q-mt-lg">
                                                                        <!-- выводим выбор организаций -->
                                    <q-select
                                        v-model="organizationID"
                                        placeholder="Выбор юр.лица"
                                        radio
                                        size='lg'
                                        :options="organizationList" 
                                        style="width:350px;"
                                        class='q-mt-sm'
                                    />

                                    <div class='shadow-2 text-center q-mr-lg'>
                                        <div class="row no-wrap q-mt-lg q-pa-sm uppercase bg-deep-purple text-white q-body-1 full-width">
                                            <div class='ellipsis col-1'></div>
                                            <div class='ellipsis col-2'>Номер счета</div>
                                            <div class='ellipsis col-3'>Год</div>
                                            <div class='ellipsis col-2'>Сумма</div>
                                            <div class='ellipsis col-4'>Комментарии</div>
                                        </div>
                                        <div v-for='charge in charges' :key='charge.id'>
                                            <div class="row no-wrap q-pa-sm bg-grey-2 q-caption full-width items-center">
                                                <div class='ellipsis col-1 q-pr-lg'><q-btn color='negative' flat size=sm icon='far fa-times-circle' @click='deleteTMPcharge(charge.id)'/></div>
                                                <div class='ellipsis col-2 q-pr-lg q-pl-md'><q-input v-model='charge.bill' align='center' type='number'/></div>
                                                <div class='ellipsis col-3 q-pr-lg q-pl-md'><q-select v-model="charge.bill_at" :options="yearList" label='sd'/></div>
                                                <div class='ellipsis col-2 q-pr-lg q-pl-md'><q-input v-model='charge.pay_value'  type="number" suffix='р' align='center'/></div>
                                                <div class='ellipsis col-4 text-left  q-pl-md'><q-input v-model='charge.comment'/></div>
                                            </div>
                                        </div>


                                        <q-btn icon="add" label='Добавить позицию' color='positive' class='q-ma-md' @click='addTMPcharge'/>
                                    </div>

                                </div>
                                <div class="col-4 justify-between text-center q-ml-lg" >
                                    <div class='q-ma-lg ellipsis'>
                                        <q-btn-group push rounded>
                                            <q-btn label="Позавчера" color=red @click='setDate(-2)'/>
                                            <q-btn label="Вчера" color='orange' @click='setDate(-1)'/>
                                            <q-btn label="Сегодня" color='positive' @click='setDate(0)'/>
                                        </q-btn-group>
                                    </div>
                                    <div>
                                        <q-datetime-picker v-model="chargeDate" type="date" />
                                    </div>
                                </div>
                            </div>
                        </q-modal-layout>
                    </form>
                </q-modal>


        <!-- Управляющие кнопки -->
                <div class='row full-width justify-end q-mb-lg'>
                    <q-btn 
                        icon='fas fa-plus'
                        label='Добавить приход'
                        color='deep-purple'
                        @click="addNewCharge"
                    />
                </div>

                <!-- Таблица с приходами -->

                <div class="shadow-1 q-pa-sm">
                    <div class="row no-wrap full-width bg-green-7 text-white uppercase text-center q-body-2 ellipsis">
                        <div class='q-pa-md border-right col-1'> </div>
                        <div class='q-pa-md border-right col-1 ellipsis' >##</div>
                        <div class='q-pa-md border-right col-2 ellipsis'>Организация</div>
                        <div class='q-pa-md border-right col-2 ellipsis'>номер счета</div>
                        <div class='q-pa-md border-right col-2 ellipsis'>дата оплаты</div>
                        <div class='q-pa-md border-right col-md-4 col-lg-1 col-xs-1 ellipsis'>сумма</div>
                        <div class='q-pa-md gt-md col-3 ellipsis'>Комментарии</div>
                    </div>

                    <div v-for='charge in allCharges' :key='charge.id'>
                        <div class="row text-center bg-grey-2 myBorder items-center q-body-1">
                            <div class='border-right col-1 justify-between'>
                                <q-btn icon='far fa-trash-alt' color='red' flat dense size='sm' class='q-mr-sm' @click='delCharge(charge.id)'/>
                                <q-btn icon='far fa-edit' color='primary' flat dense size='sm'/>
                            </div>
                            <div class='q-pa-sm border-right col-1 ellipsis'>{{charge.id}}</div>
                            <div class='q-pa-sm border-right col-2 ellipsis'>{{getOrgName(charge.org)}}</div>
                            <div class='q-pa-sm border-right col-2 ellipsis'>{{charge.bill}}</div>
                            <div class='q-pa-sm border-right col-2 ellipsis'>{{getPrettyDate(charge.pay_at)}}</div>
                            <div class='q-pa-sm border-right col-md-4 col-lg-1 col-xs-1 ellipsis'>{{charge.pay_value}}</div>
                            <div class='q-pa-sm gt-md col-3 text-left ellipsis'>{{charge.comment}}</div>          
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

/* eslint-disable */
export default {
    
    name : 'chargeList',

    components : {
    },

    data() {
        return {
            chargeDialog : false,
            organizationID : null,
            chargeDate : new Date(),
            yearList : [],
            charges : [
                {id:1, bill:null, bill_at: this.getCurrentYear, pay_value:null, comment:null},
            ],
            chargeIndex : 1,
        }
    },

    created() {
        // формируем список лет - 5 последних лет
        let currentYear = this.getCurrentYear;
        for (let i = 0; i < 5; i++) {            
            this.yearList.push({label:(currentYear - i)+"", value:(currentYear - i)})
        }
        this.charges[0].bill_at = this.getCurrentYear
        
        this.$store.dispatch('getCharges'); // получаем последние записи
        if (this.$store.getters.getAllOrganization.length == 0) {   // на всякий случай проверяем загрузку организаций
            this.$store.dispatch('getOrganization');
        }

    },

    computed :{
        getCurrentYear() {
            let d = new Date();
            return 1*d.getFullYear()
        },

        allCharges() {
            return this.$store.getters.allCharges;
        },

        organizationList() { // список всех организаций

            var list = [];
            if (this.$store.getters.getAllOrganization == undefined) return list;
            this.$store.getters.getAllOrganization.map((value,key)=>{
                list.push({label:value.name, value:value.id});
            });
            return list;

        }
    },

    methods : {
        
        emptyTPMData(){
            this.charges.splice(0, this.charges.length);
            this.charges.bill_at = this.getCurrentYear
            this.chargeIndex = 0;
            this.addTMPcharge();// добавляем первую пустую запись
            this.chargeDate = new Date();
            this.organizationID = null;
        },

        addTMPcharge(){
            this.chargeIndex +=1;
            this.charges.push({
                id:this.chargeIndex,
                bill : null,
                bill_at : this.getCurrentYear,
                pay_value : null,
                comment : null,
            })
        },

        deleteTMPcharge(id) {
            let index = this.charges.findIndex(item => item.id==id);
            this.charges.splice(index, 1);
        },

        setDate(shift) {
            let d = new Date();
            d.setDate(d.getDate()+shift)
            this.chargeDate = d;
        },

        cancelChargeDialog(){
            this.chargeDialog = false;
            this.emptyTPMData();
        },

        saveCharge() {
            // проверяем, что задана организация
            if (this.organizationID == null) {
                this.$admns.showNotify('Не выбрано юридическое лицо','error', 'Проверка данных')
                return;
            }
            //проверяем все счета на корректность ввода
            var isCorrect = true;
            this.charges.forEach(element => {
                if ((element.bill==null)||(element.pay_value==null)||(element.bill.length==0)||(element.pay_value.length==0)) {
                    isCorrect = false;
                } 
            });
            if (!isCorrect) {
                this.$admns.showNotify('Проверьте данные оплат: номер счета и сумма должны быть заполнены.','error','Проверка данных')
                return;
            }
// Тут якобы все проверки пройдены - отправляемся на сервер
            this.$store.dispatch('addNewCharges', {org : this.organizationID, pay_at : this.chargeDate, charges : this.charges})
            .then(() => {
                this.chargeDialog = false;
                this.emptyTPMData();
            })
            .catch();
            
        },

        addNewCharge(){
            this.chargeDialog = true;
        },
        
        delCharge(id) {
            
            this.$q.dialog({
                title : 'Внимание!',
                message : 'Вы действительно хотите удалить запись об оплате по безналичному расчету?',
                ok:'Да, удалить',
                cancel : 'Отмена'
            })
            .then(()=>{
                this.$store.dispatch('deleteCharge', id)
                .then(() => {
                    this.$admns.showNotify('Запись помещена на удаление','success','Сообщение системы');
                })
                .catch(error=>{
                    console.log(error);
                })
            })

        },

        getOrgName(id) {
            let result = '';
            let q = this.$store.getters.getOrganizationById(id);
            if (q != undefined) result = q.name;
            return result;
        },
        
        getPrettyDate(d) {
            let result = new Date(d);
            if (result == undefined) return '';
            return result.toLocaleDateString('ru');
        },
    }

}
</script>

<style>

    .border-left {
        border-left : 1px solid white;
    }
    .border-right {
        border-right : 1px solid white;
    }
    .mySelect:hover {
        background-color: red;
    }
    .myBorder {
        border : 1px solid rgb(221, 221, 221);
    }
</style>
